// extracted by mini-css-extract-plugin
export default {"NftListList":"oW6WROtUBXjF_VXoP5_p","NftListListContent":"OoD9v8hh_T8jNp_pr81r"};